import { useContext, useEffect, useState } from 'react';
import { SelectedReports } from 'reporting-action-components/reportingActions/exportReport/ExportReportButton';
import { getSort } from 'reporting-data/report/configReportGetters';
import { setConfigReportLimit } from 'reporting-data/report/configReportSetters';
import { convertToSearchReport } from 'reporting-data/report/report-transformations/searchReportTransformations';
import PlatformReportResolver from 'reporting-ui-components/components/PlatformReport/PlatformReportResolver';
import { EnablementTrackingContext } from '../../../../monitoring/EnablementTrackingContext';
import { useTableRowLimit } from '../hooks/useTableRowLimit';
import { SRVDatasetTableActionsBar } from './SRVDatasetTableActionsBar';
import { useCrmObjectTableReportComponent } from './CrmObjectTable/CrmObjectTableReportComponentContext';
import { useIsCrmObjectTableSupported } from './CrmObjectTable/useIsCrmObjectTableSupported';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function convertToDatasetTableReport({
  report,
  sort,
  rowLimit,
  onRowLimitChange
}) {
  const tableReport = convertToSearchReport(report, sort).delete('id').set('description', report.get('description')).setIn(['displayParams', 'rowsPerPage', 'onChange'], onRowLimitChange);
  return setConfigReportLimit(tableReport, rowLimit);
}
export function SRVDatasetTableConfigReport({
  previewReport,
  suppressActionsBar = false
}) {
  const {
    trackingApplicationName,
    trackingAssetType,
    trackingScreenName
  } = useContext(EnablementTrackingContext);
  const {
    rowLimit,
    onRowLimitChange
  } = useTableRowLimit();

  // Convert the original report to an unsummarized table (search) report,
  // maintaining the sort order from the parent. If the sort is undefined/empty, it will be defaulted based on the data type
  const [searchPreviewReport, setSearchPreviewReport] = useState(convertToDatasetTableReport({
    report: previewReport,
    sort: getSort(previewReport),
    rowLimit,
    onRowLimitChange
  }));
  useEffect(() => {
    // On subsequent updates to the external report, update the internal report, but DON'T use the sort from the external report,
    // otherwise that would overwrite any changes the user has made to the sort in this view, which we want to respect
    // (There should be no way to update the sort externally in this view anyway)
    // But if the user has updated the filters, e.g., those will have been updated on the external report and should
    // trickle down to the internal report. Note: If no sort is passed in, this transform function will
    // default the sort based on the data type
    setSearchPreviewReport(prevSearchPreviewReport => convertToDatasetTableReport({
      report: previewReport,
      sort: getSort(prevSearchPreviewReport),
      rowLimit,
      onRowLimitChange
    }));
  }, [previewReport, rowLimit, onRowLimitChange]);
  const CrmObjectTableReportComponent = useCrmObjectTableReportComponent();
  const isCrmObjectTableSupported = useIsCrmObjectTableSupported({
    previewReport: searchPreviewReport
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!suppressActionsBar && /*#__PURE__*/_jsx(SRVDatasetTableActionsBar, {
      report: searchPreviewReport,
      selectedReport: SelectedReports.unsummarizedTable
    }), isCrmObjectTableSupported && CrmObjectTableReportComponent ? /*#__PURE__*/_jsx(CrmObjectTableReportComponent, {
      previewReport: searchPreviewReport
    }) : /*#__PURE__*/_jsx(PlatformReportResolver, {
      lazyReportResolve: false,
      report: searchPreviewReport,
      useInlineLabels: false,
      trackingApplicationName: trackingApplicationName,
      trackingAssetType: trackingAssetType,
      trackingScreenName: trackingScreenName,
      onReportChange: setSearchPreviewReport
    })]
  });
}